import styled from 'styled-components';

export const StyledLinkedText = styled.a`
  text-decoration: none;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.brand.color};
  font-weight: bold;
`;
